import { ApiService } from '../../services/api_service';
import btnStyle from '../../core/elements/buttons.less';
import * as classNames from 'classnames';
import * as config from '../../wips.config.js';
import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import { DialogCO2Entfernung } from './dialogs/DialogCO2Entfernung';
import { DialogCO2EntfernungMobi } from './dialogs/DialogCO2EntfernungMobi';
import { DialogCO2Kosten } from './dialogs/DialogCO2Kosten';
import { DialogCO2LieferEntfernung } from './dialogs/DialogCO2LieferEntfernung';
import { DialogCO2ServiceMail } from './dialogs/DialogCO2ServiceMail';
import { DialogCO2Verbrauch } from './dialogs/DialogCO2Verbrauch';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { filterBundle } from './functions/filterBundle';
import { getAdditionalInfo, getAdditionalIconInfo } from '../../core/forms/helpers/getAdditionalInfo';
import { getExtraFormElement } from './custom/getExtraFormElement';
import { getFormRequired } from './functions/getFormRequired';
import { IDs } from '../../helpers/IDs';
import { isFieldHidden } from './functions/isFieldHidden';
import { lazyInject } from '../../services/inversify';
import { onFormChangeUniversal } from './functions/onFormChange';
import * as React from 'react';
import { StructureTool } from '../../core/forms/helpers/structure_tool';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldUniversal } from './functions/validateField';
import { WActionButton } from '../../core/elements/WActionButton';
import { WForm, WFormConfig, WFormConfigItem, WFormData } from '../../core/forms/WFormFramework';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

interface DateneingabeCO2KomplexFormProps extends React.ClassAttributes<any> {
    showMode?: boolean;
    WFormId?: string;
    entity: any;
    module?: string;
    jahr: number;
    data: any;
    dataItem: any;
    standort: any;
    isFirst: boolean;
    formKey?: string;
    layout?: string;
    presetFormConfig?: WFormConfig;
    customFormConfig?: any;
    currentYear?: number;
    posFieldsHelpBeginning?: boolean;
    formSimpleValidationMsg?: any;
    selectOptionAsRadio?: boolean;
    disableFieldSelectDefaultOptions?: any;
    forceOnChange?: boolean; // Wenn true, wird onChange auch bei diff === 0 aufgerufen
    externalDescriptionElement?: JSX.Element | Array<JSX.Element> | string | ((formData: any) => JSX.Element);
    externalTopElement?: JSX.Element | Array<JSX.Element>;
    customCssStyle?: any;
    hideAllFields?: boolean;
    additionalFormItems?: Array<WFormConfigItem>;
    isInAssisten?: boolean;
    isPruefung?: boolean; // Flag für AssistentPruefer
    formGroupOrder?: Array<any>;
    onValidate?: (data: any) => void;
    customOnSaveDone?: (entityName: string, values: any) => void;
    customOnDelDone?: (entityName: string, row: any) => void;
    onCurrentYearChange?: (year: number) => void;
    onChange?: (entityName: string, formValues: any, onSaveDone?: () => void, timeout?: number, field?: any) => void;
    reloadData?: (entityName: string) => void;
    announceTid?: (tid: number, wasDeleted: boolean) => void;
    onValidationStateChange?: (state: any) => void;
    getExtraElement?: (
        isFirst: boolean, standortSelected: any, jahr: number, entity: any, values: any, setValues: (values: any) => void,
        disabled?: boolean, id?: number, showMode?: boolean
    ) => JSX.Element;
    getExtraElement2?: (
        isFirst: boolean, standortSelected: any, jahr: number, entity: any, values: any, setValues: (values: any) => void,
        disabled?: boolean, id?: number, showMode?: boolean
    ) => JSX.Element;
    getFunktionBtn?: (isFirst: boolean, entity: any, values: any, showMode?: boolean) => JSX.Element;
    reloadBundle?: () => void;
    bundleFilterFunc?: (bundle: any, data: any) => void;
    onFormChangeInteractive?(data: WFormData, onValueChange: (name: string, value: any) => void): void;
    renderBtnDetailierteErfassung?: (onWillChange?: () => void) => JSX.Element;
}

interface DateneingabeCO2KomplexFormState {
    formConfig: any;
    formValues: any;
    renderForm: boolean;
    showDialog: string;
    zaehlerTid: number;
    lieferantTid: number;
    isFormSaveDone: boolean;
    infoDlgContent: any;
}

export class DateneingabeCO2KomplexForm extends React.Component<DateneingabeCO2KomplexFormProps, DateneingabeCO2KomplexFormState> {

    constructor(props: any) {
        super(props);
        this.state = {
            formConfig: null,
            formValues: this.props.dataItem,
            renderForm: true,
            showDialog: null,
            zaehlerTid: null,
            lieferantTid: null,
            isFormSaveDone: true,
            infoDlgContent: null
        };
        this.onFormConfigGenerated = this.onFormConfigGenerated.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.validateField = this.validateField.bind(this);
        this.getVerbrauchBtn = this.getVerbrauchBtn.bind(this);
        this.getKostenBtn = this.getKostenBtn.bind(this);
        this.getLieferantBtn = this.getLieferantBtn.bind(this);
        this.getEntfernungBtn = this.getEntfernungBtn.bind(this);
        this.getEntfernungBtnMobi = this.getEntfernungBtnMobi.bind(this);
        this.getLieferEntfernungBtn = this.getLieferEntfernungBtn.bind(this);
        this.getMessage = this.getMessage.bind(this);
        this.getMessageIcon = this.getMessageIcon.bind(this);

        this.komplexFormId = props.WFormId + '-Wrapper';
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private devFeatures: boolean = config.devFeatures || false;
    private required: any = getFormRequired(IDs.MOD_ETOOL, this.props.entity.entity, this.props.dataItem, this.props.data);
    private validation: any;
    private currentFormTarget: any;
    private komplexFormId: string;
    private teilstreckenEntities: any = [
        IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, // 4
        IDs.ENT_CO2_SCOPE3_REISEN, // 6
        IDs.ENT_CO2_SCOPE3_PENDELN, // 7
        IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT // 9
    ];

    componentDidMount(): void {
        this.loadFormConfig();
        this.init();
        this.recoverInfoDlgContent();
    }

    componentDidUpdate(prevProps: any, prevState: any): void {
        if (!this.state.showDialog) {
            this.setDialogState(prevState.formValues);
            // WKETOOL-55, Wenn man auf weiteres Material „klickt“, verschwindet nach einer Sekunde das Eingabefeld ...
            this.setMessage(prevState.formValues);
        }
    }

    componentWillUnmount(): void {
        this.restoreInfoDlgContent();
    }

    restoreInfoDlgContent() {
        const { infoDlgContent } = this.state;
        const contextId = this.getInfoDlgContentContextKey();
        if (infoDlgContent) {
            this.contextService.set(contextId, infoDlgContent);
        }
    }

    recoverInfoDlgContent() {
        const contextId = this.getInfoDlgContentContextKey();
        const infoDlgContent = this.contextService.get(contextId);
        if (infoDlgContent) {
            this.setState({ infoDlgContent });
        }
    }

    getInfoDlgContentContextKey() {
        const { formValues } = this.state;
        const key = ['DateneingabeCO2KomplexForm', (formValues._formKey || '_N/A_'), 'InfoDlgContent'].join('_');
        return key;
    }

    compareFormValues(ent: string, a: any, b: any) {
        if ((!a && b) || (!b && a)) {
            return 1;
        }
        let d = 0;
        Object.keys(b).forEach((k: string) => {
            if (k.endsWith('_archiv_filename') || k.endsWith('_archiv_rawdata') || k.endsWith('_archiv_delete')) {
                // Archiv-Felder als Ausnahmen
                if (a[k] !== b[k]) {
                    d++;
                }
                return;
            }
            if (a.hasOwnProperty(k) && b.hasOwnProperty(k)
                && !a.hasOwnProperty(k + '_orig') && k !== '_formKey' && k !== 'datum'
                && !k.endsWith('_name')) {
                if (a[k] !== b[k] && !(!a[k] && !b[k]) /* WICHTIG !! */) {
                    // console.log(k, 'a', a[k], 'b', b[k]);
                    d++;
                }
            }
        });
        return d;
    }

    compareFormValues2(a: any, b: any) {
        if ((!a && b) || (!b && a)) {
            return 1;
        }
        let d = 0;
        Object.keys(b).forEach((k: string) => {
            if (a.hasOwnProperty(k) && b.hasOwnProperty(k)) {
                if (a[k] !== b[k] && !(!a[k] && !b[k])) {
                    d++;
                }
            } else {
                d++;
            }
        });
        return d;
    }

    getDialogKey(): string {
        const { formValues } = this.state;
        switch (this.props.entity.entity) {
            // case IDs.ENT_CO2_SCOPE3_ABFALL:
            // case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF:
            //     return 'sendServiceMail';
            case IDs.ENT_CO2_SCOPE3_PENDELN:
            case IDs.ENT_CO2_SCOPE3_REISEN:
                switch ((formValues || {}).modus) {
                    case 'fuel_based':
                        return 'editVerbrauch';
                    case 'spend_based':
                        return 'editKosten';
                    case 'distance_based':
                        return 'editEntfernung';
                }
                break;
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
                switch ((formValues || {}).modus) {
                    case 'fuel_based':
                        return 'editVerbrauch';
                    case 'spend_based':
                        return 'editKosten';
                    case 'distance_based':
                        // WKETOOL-99
                        const isMobilitaet = this.apiService.getBereichKey() !== 'handwerk' && (formValues || {}).art === 'mobilitaet';
                        return isMobilitaet ? 'editEntfernungMobi' : 'editLieferEntfernung';
                }
                break;
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
                switch ((formValues || {}).modus) {
                    case 'fuel_based':
                        return 'editVerbrauch';
                    case 'spend_based':
                        return 'editKosten';
                    case 'distance_based':
                        return 'editLieferEntfernung';
                }
                break;
            default:
                return null;
        }
    }

    getLieferantBtn() {
        const { formValues } = this.state;
        const configLieferantTid: any = (this.props.customFormConfig || {}).lieferant_tid || {};
        if (Object.keys(configLieferantTid).some((key: string) => ['hidden', 'hidden_input', 'readonly'].indexOf(key) !== -1 && configLieferantTid[key])) {
            return null;
        }
        const lieferantTid = formValues
            ? typeof formValues.lieferant_tid === 'number' && formValues.lieferant_tid > 0
                ? formValues.lieferant_tid
                : typeof formValues.lieferant_tid_orig === 'number' && formValues.lieferant_tid_orig > 0
                    ? formValues.lieferant_tid_orig
                    : null
            : null;
        // console.log(formValues, lieferantTid);
        let styleProps: any = { marginLeft: 5, marginRight: 0 };
        if (this.props.layout === 'sidebysideComplexGreen') {
            styleProps = { width: 20, height: 20, marginRight: 8 };
        }
        // Wenn das Speichern noch im Prozess ist, darf der Dialog nicht geöffnet werden
        const { isFormSaveDone } = this.state;
        if (!isFormSaveDone) {
            // styleProps.backgroundColor = this.props.layout === 'sidebysideComplexGreen' ? '#d7e4bd' : null;
            styleProps.cursor = 'not-allowed';
        }
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {lieferantTid > 0 &&
                    <WActionButton
                        tooltip='Lieferfirma bearbeiten'
                        label='Lieferfirma bearbeiten'
                        action='edit'
                        key='btn_edit_lieferant'
                        styleProps={styleProps}
                        onAction={() => this.setState({ showDialog: 'editLieferant', lieferantTid })}
                    />
                }
                <WActionButton
                    tooltip='Neue Lieferfirma anlegen'
                    label='Neue Lieferfirma anlegen'
                    action='add'
                    key='btn_add_lieferant'
                    styleProps={styleProps}
                    disabled={!isFormSaveDone}
                    onAction={() => this.setState({ showDialog: 'editLieferant', lieferantTid: 0 })}
                />
            </div>
        );
    }

    getVerbrauchBtn() {
        const { customFormConfig, layout, entity } = this.props;
        const { formValues, isFormSaveDone } = this.state;
        const label = 'Rechner';
        let disabled: boolean = false;
        let hidden: boolean = false;
        let styleProps: any = { marginLeft: 5, marginRight: 0 };
        if (layout === 'sidebysideComplexGreen') {
            styleProps = { ...styleProps, ...{ width: 20, height: 20, marginRight: 8 } };
        }
        if (this.teilstreckenEntities.indexOf(entity.entity) !== -1) {
            // console.log(customFormConfig, formValues);
            disabled = !(+(this.state.formValues || {}).teilstrecken_orig === 1 /*Ja*/);
            hidden = (formValues || {}).modus !== 'fuel_based';
        }
        if (!isFormSaveDone || disabled) {
            styleProps.cursor = 'not-allowed';
        }
        return !hidden ?
            <WActionButton
                label={label}
                tooltip={label}
                key='editVerbrauch'
                action='calculator'
                divStyle={{ textAlign: 'right' }}
                styleProps={styleProps}
                disabled={!isFormSaveDone || disabled}
                onAction={() => this.checkParentTid(() => this.setState({ showDialog: 'editVerbrauch' }))}
            /> : null;
    }

    getKostenBtn() {
        const { customFormConfig, layout, entity } = this.props;
        const { formValues, isFormSaveDone } = this.state;
        const label = 'Rechner';
        let disabled: boolean = false;
        let hidden: boolean = false;
        let styleProps: any = { marginLeft: 5, marginRight: 0 };
        if (layout === 'sidebysideComplexGreen') {
            styleProps = { ...styleProps, ...{ width: 20, height: 20, marginRight: 8 } };
        }
        if (this.teilstreckenEntities.indexOf(entity.entity) !== -1) {
            // console.log(customFormConfig, formValues);
            disabled = !(+(this.state.formValues || {}).teilstrecken_orig === 1 /*Ja*/);
            hidden = (formValues || {}).modus !== 'spend_based';
        }
        if (!isFormSaveDone || disabled) {
            styleProps.cursor = 'not-allowed';
        }
        return !hidden ?
            <WActionButton
                label={label}
                tooltip={label}
                key='editKosten'
                action='calculator'
                styleProps={styleProps}
                disabled={!isFormSaveDone || disabled}
                onAction={() => this.checkParentTid(() => this.setState({ showDialog: 'editKosten' }))}
            /> : null;
    }

    getEntfernungBtn() {
        const { customFormConfig, layout, entity } = this.props;
        const { formValues, isFormSaveDone } = this.state;
        const label = 'Rechner';
        let disabled: boolean = false;
        let hidden: boolean = false;
        let styleProps: any = { marginLeft: 5, marginRight: 0 };
        if (layout === 'sidebysideComplexGreen') {
            styleProps = { ...styleProps, ...{ width: 20, height: 20, marginRight: 8 } };
        }
        if ([IDs.ENT_CO2_SCOPE3_PENDELN, IDs.ENT_CO2_SCOPE3_REISEN].indexOf(entity.entity) !== -1) {
            disabled = !(+(formValues || {}).teilstrecken_orig === 1 /*Ja*/);
            hidden = !!((customFormConfig || {}).entfernung || {}).hidden_input;
        }
        if (!isFormSaveDone || disabled) {
            // styleProps.backgroundColor = this.props.layout === 'sidebysideComplexGreen' ? '#d7e4bd' : null;
            styleProps.cursor = 'not-allowed';
        }
        return !hidden ?
            <WActionButton
                label={label}
                tooltip={label}
                key='editEntfernung'
                action='calculator'
                styleProps={styleProps}
                disabled={!isFormSaveDone || disabled}
                onAction={() => this.checkParentTid(() => this.setState({ showDialog: 'editEntfernung' }))}
            /> : null;
    }

    getEntfernungBtnMobi() {
        // WKETOOL-99
        const { customFormConfig, layout, entity } = this.props;
        const { formValues, isFormSaveDone } = this.state;
        const label = 'Rechner';
        let disabled: boolean = false;
        let hidden: boolean = false;
        let styleProps: any = { marginLeft: 5, marginRight: 0 };
        if (layout === 'sidebysideComplexGreen') {
            styleProps = { ...styleProps, ...{ width: 20, height: 20, marginRight: 8 } };
        }
        const isMobilitaet = entity.entity === IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT && this.apiService.getBereichKey() !== 'handwerk' && (formValues || {}).art === 'mobilitaet';
        if (isMobilitaet) {
            disabled = !(+(formValues || {}).teilstrecken_orig === 1 /*Ja*/);
            hidden = !!((customFormConfig || {}).entfernung || {}).hidden_input;
        }
        if (!isFormSaveDone || disabled) {
            // styleProps.backgroundColor = this.props.layout === 'sidebysideComplexGreen' ? '#d7e4bd' : null;
            styleProps.cursor = 'not-allowed';
        }
        return !hidden ?
            <WActionButton
                label={label}
                tooltip={label}
                key='editEntfernungMobi'
                action='calculator'
                styleProps={styleProps}
                disabled={!isFormSaveDone || disabled}
                onAction={() => this.checkParentTid(() => this.setState({ showDialog: 'editEntfernungMobi' }))}
            /> : null;
    }

    getLieferEntfernungBtn() {
        const label = 'Rechner';
        let disabled: boolean = false;
        let hidden: boolean = false;
        let styleProps: any = { marginLeft: 5, marginRight: 0 };
        if (this.props.layout === 'sidebysideComplexGreen') {
            styleProps = { ...styleProps, ...{ width: 20, height: 20, marginRight: 8 } };
        }
        if ([IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT, IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT].indexOf(this.props.entity.entity) !== -1) {
            disabled = !(+(this.state.formValues || {}).teilstrecken_orig === 1 /*Ja*/);
            hidden = !!((this.props.customFormConfig || {}).entfernung || {}).hidden_input;
        }
        // Wenn das Speichern noch im Prozess ist, darf der Rechner nicht geöffnet werden
        const { isFormSaveDone } = this.state;
        if (!isFormSaveDone || disabled) {
            // styleProps.backgroundColor = this.props.layout === 'sidebysideComplexGreen' ? '#d7e4bd' : null;
            styleProps.cursor = 'not-allowed';
        }
        return !hidden ?
            <WActionButton
                label={label}
                tooltip={label}
                key='editLieferEntfernung'
                action='calculator'
                styleProps={styleProps}
                disabled={!isFormSaveDone || disabled}
                onAction={() => this.checkParentTid(() => this.setState({ showDialog: 'editLieferEntfernung' }))}
            /> : null;
    }


    getMsgId(key: string) {
        const data: any = this.state.formValues || {};
        const id: string = this.props.isInAssisten
            ? `message-${this.props.entity.entity}-${data.jahr}-${+data.tid}-${key}`
            : `message-${this.props.WFormId}-${key}`;
        return id;
    }

    getMsgId0(key: string) {
        const data: any = this.state.formValues || {};
        const id0: string = `message-${this.props.entity.entity}-${data.jahr}-0-${key}`;
        return id0;
    }

    getMessage(key: string, elementRef?: any, elementState?: any) {
        const data: any = this.state.formValues || {};
        const entity = this.props.entity.entity;
        const id: string = this.getMsgId(key);
        const id0: string = this.getMsgId0(key);

        const additionalInfo: any = getAdditionalInfo(entity, key, data, this.props.isInAssisten);
        const additionalInfo2 = this.getAdditionalInfo2(entity, key, data, () => {
            if (entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF && key === 'art_tid') {
                const { formValues } = this.state;
                if (+formValues.kategorie_tid !== 4) {
                    formValues.kategorie_tid = 4;
                    this.setState({ formValues });
                    this.props.onChange(entity, formValues, null, 0 /* sofort!! */);
                }
            }
        });

        if (!additionalInfo) {
            return null;
        }

        if (elementState && elementState.hasOwnProperty('isMenuOpen') && elementState.isMenuOpen) {
            // WKETOOL-69: Der Hinweis darf das Dropdown nicht blockieren.
            return null;
        }

        const elementRect = elementRef && elementRef.current ? elementRef.current.getBoundingClientRect() : undefined;

        const onCloseMessage = () => {
            document.getElementById(id).style.display = 'none';
            this.contextService.set(id, false);
            if (this.props.isInAssisten) {
                this.contextService.set(id0, false);
            }
        };

        return (
            <div
                id={id}
                style={{
                    position: 'absolute',
                    ...((this.props.layout === 'sidebysideComplex' || this.props.layout === 'sidebysideComplexGreen')
                        ? { top: 26, marginLeft: -190 }
                        : { marginLeft: -470, ...(elementRect ? { top: elementRect.top + 65 } : { marginTop: 40 }) }
                    ),
                    width: (this.props.layout === 'sidebysideComplex' || this.props.layout === 'sidebysideComplexGreen') ? 300 : 453,
                    fontSize: 11,
                    borderRadius: 5,
                    zIndex: 10000,
                    backgroundColor: 'rgba(255, 255, 200, 0.9)',
                    padding: '22px 8px 8px 8px',
                    border: '1px solid #aaa',
                    display: this.contextService.get(id) || (this.props.isInAssisten && this.contextService.get(id0)) ? 'block' : 'none',
                    cursor: 'pointer'
                }}
                onClick={onCloseMessage}
            >
                <span
                    style={{
                        fontSize: 12, fontWeight: 'bold', textDecoration: 'underline', top: 5, left: 5, position: 'absolute',
                        display: 'inline-block', cursor: 'default'
                    }}
                >
                    Hinweis
                </span>
                <span
                    style={{
                        fontSize: 13, color: 'red', backgroundColor: 'silver', top: 5, right: 5, padding: '0 4px 0 4px', borderRadius: 5,
                        position: 'absolute', display: 'inline-block', cursor: 'pointer'
                    }}
                    title='Schließen'
                    onClick={onCloseMessage}
                >
                    x
                </span>
                {additionalInfo}
                {additionalInfo2}
            </div>
        );
    }

    getAdditionalInfo2(entity: string, field: string, values?: any, onWillChange?: () => void) {
        const { renderBtnDetailierteErfassung } = this.props;
        switch (entity) {
            case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF:
                if (field === 'art_tid' && (values || {}).art_tid === -2) {
                    const config = this.props.data[IDs.ENT_KONFIGURATION][0];
                    if (config.co2_fussabdruck_modus === 'simple' && typeof renderBtnDetailierteErfassung === 'function') {
                        // Scope 3.1, Einfacher Modus, bei Auswahl "Dienstleistung" in der gelben Box die Möglichkeit zur Änderung des "detaillierten Modus" vorsehen
                        return <div>
                            <span>Die Eingabe von Dienstleistungen ist auch über die detaillierte Erfassung möglich:</span>
                            {renderBtnDetailierteErfassung(onWillChange)}
                        </div>;
                    }
                }
                break;
        }
        return null;
    }

    getMessageIcon(key: string) {
        const isAdmin = this.apiService.isAdmin();
        if (!this.devFeatures || !isAdmin) {
            return false;
        }
        const { entity, layout } = this.props;
        const data: any = this.state.formValues || {};
        const infoDlgContent: any = getAdditionalIconInfo(entity.entity, key, data, this.props.data, layout !== 'sidebysideComplexGreen');
        if (!infoDlgContent) {
            return null;
        }
        return <button
            style={{
                backgroundColor: 'transparent',
                ... (layout === 'sidebysideComplexGreen' ? { marginRight: 10, marginLeft: -5 } : { marginRight: 0 })
            }}
            className={classNames(btnStyle.actionButtonSmall, btnStyle.info)}
            onClick={() => this.setState({ infoDlgContent })}
        />;
    }
    // Wir müssen zuerst sichern, dass es eine tid gibt, die dann als parent_tid dient.
    checkParentTid(callback: () => void) {
        const { entity } = this.props;
        const { formValues } = this.state;
        if (!formValues.tid || formValues.tid === 0) {
            this.dataService.saveData(entity.entity, formValues, null, false, (suc: boolean, saveTid: number) => {
                if (suc && saveTid > 0) {
                    // console.log(saveTid);
                    formValues.tid = saveTid;
                    this.setState({ formValues }, callback);
                }
            }, IDs.MOD_ETOOL);
        } else {
            callback();
        }
    }

    init(): void {
        const data: any = this.state.formValues || {};
        const key: string = this.getDialogKey() || null;
        const contextKey: string = this.getContextKey(this.props.jahr);
        this.validation = {};
        delete this.required.jahr;
        delete this.required.standort_tid;

        if (key && this.contextService.get(contextKey)) {
            this.setState({ showDialog: key });
        } else if (key) {
            this.contextService.set(contextKey, false);
            this.contextService.set(`${contextKey}-prev`, data);
        }
    }

    getContextKey(jahr: number, presetKey?: string) {
        const { isInAssisten, WFormId } = this.props;
        const entity: string = this.props.entity.entity || null;
        const key = presetKey || this.getDialogKey() || null;
        const contextKey: string = isInAssisten ? `dlg-${entity}-${jahr}-${key}` : `dlg-${WFormId}-${key}`;
        // console.log(contextKey, formValues, this.props.formKey);
        return contextKey;
    }

    isFormEmpty(d: any) {
        const { entity } = this.props;
        const entName = entity.entity;
        let e = true;
        Object.keys(d).forEach((k: string) => {
            if (
                k !== 'datum' && k !== 'abrechnungszeitraum_bis' && k !== 'abrechnungszeitraum_von' && k !== 'abrechnungstage'
                && k !== 'gebaeude_tid' && k !== 'jahr' && k !== 'monat' && k !== 'energietraeger_tid_name' && k !== 'standort_tid'
                && k !== 'standort_tid_orig' && k !== 'standort_tid_name' && k !== 'anlagen_eigenstrom_typ_tid'
                && k !== 'anlagen_eigenstrom_typ' && k !== 'tid' && k !== '_formKey' && k !== 'mandant'
            ) {
                if (d[k] && d[k] !== '' && d[k] !== 0) {
                    // console.log(k, d[k]);
                    e = false;
                }
            }
        });
        return e;
    }

    loadFormConfig() {
        if (this.props.presetFormConfig) {
            this.onFormConfigGenerated(this.props.presetFormConfig);
        } else {
            const struct_tool = new StructureTool(IDs.MOD_ETOOL);
            struct_tool.generateFormConfig(this.props.entity.entity, this.onFormConfigGenerated);
        }
    }

    onFormChange(formData: any, item?: any): void {
        const { data, entity, onChange, announceTid } = this.props;
        const entityName = entity.entity;
        // valuesNew
        onFormChangeUniversal(entity.entity, formData, this, data);
        const valuesNew = formData.getAllValues();

        if (!this.currentFormTarget) {
            // console.log('onFormChange', 'Datenänderung wegen Vorbelegungen', 'Übersprungen!');
            // Wenn es keinen currentFormTarget gibt, wurde die Datenänderung nicht vom User gemacht.
            // Deswegen triggern onFormChange nicht, um leere Datensätze zu vermeiden, lassen aber Validation und onFormChangeUniversal.
            return;
        }

        if (this.isFormEmpty(valuesNew)) {
            // delete item
            if (valuesNew.tid > 0) {
                console.log('Form leer! -> delData', entityName, valuesNew.tid);
                this.dataService.delData(entityName, IDs.MOD_ETOOL, { tid: valuesNew.tid }, {}, () => {
                    if (typeof this.props.onValidate === 'function') {
                        Object.keys(this.validation || {}).forEach((field: string) => this.validation[field] = null);
                        this.props.onValidate({
                            entity: this.props.entity.entity,
                            jahr: this.props.jahr,
                            tid: valuesNew.tid || null,
                            fields: this.validation
                        });
                    }
                    this.triggerService.fire('reload', entityName);
                    if (announceTid) {
                        announceTid(valuesNew.tid, true);
                    }
                    valuesNew.tid = 0;
                }
                );
            }
        } else {
            // valuesOld
            const valuesOld = Array.isArray(data[entityName]) && data[entityName].find((d: any) => d.tid === valuesNew.tid);
            // compare
            const diff = this.compareFormValues(entityName, valuesOld, valuesNew);
            // console.log(valuesOld, valuesNew, diff);
            if (diff > 0 || this.props.forceOnChange) {
                if (typeof onChange === 'function') {
                    this.setState({ isFormSaveDone: false }, () => {
                        onChange(entity.entity, valuesNew, () => {
                            // Wir haben triggerService.fire('reload’) in componentWillUnmount verschoben.
                            // if (this.props.customOnSaveDone) {
                            //     this.props.customOnSaveDone(entity.entity, valuesNew);
                            // }
                            this.setState({ isFormSaveDone: true });
                        }, null, item);
                    });
                }
            }
        }
        this.setState({ formValues: valuesNew, renderForm: true });
    }

    public onFormConfigGenerated(formConfig: WFormConfig) {
        if (!formConfig) {
            return;
        }
        const { formValues } = this.state;
        if (this.props.customFormConfig) {
            const cf = this.props.customFormConfig;
            Object.keys(cf).forEach((key: string) => {
                const idx = formConfig.items.findIndex((it: any) => (it.key || it.id) === key);
                if (idx >= 0) {
                    if (cf[key].label) {
                        formConfig.items[idx].label = cf[key].label;
                    }
                    if (cf[key].hasOwnProperty('required')) {
                        formConfig.items[idx].required = cf[key].required;
                    }
                    if (cf[key].hasOwnProperty('readonly')) {
                        formConfig.items[idx].readonly = cf[key].readonly;
                    }
                    if (cf[key].hasOwnProperty('hidden')) {
                        formConfig.items[idx].hidden = cf[key].hidden;
                    }
                    if (cf[key].hidden_input) {
                        formConfig.items[idx].hidden_input = true;
                    }
                    if (cf[key].radio) {
                        formConfig.items[idx].radio = true;
                    }
                    if (cf[key].disable_default) {
                        formConfig.items[idx].disable_default = true;
                    }
                    if (cf[key].show) {
                        formConfig.items[idx].show = true;
                    }
                    if (cf[key].hidden_input) {
                        if (this.props.isInAssisten) { // Im Assistenten ganz ausblenden
                            formConfig.items[idx].hidden = true;
                        } else {
                            formConfig.items[idx].hidden_input = true;
                        }
                    }
                    if (cf[key].hidden_msg) {
                        formConfig.items[idx].hidden_msg = cf[key].hidden_msg;
                    }
                    if (cf[key].placeholder) {
                        formConfig.items[idx].placeholder = cf[key].placeholder;
                    }
                    if (cf[key].bundle_output) {
                        formConfig.items[idx].bundle_output = cf[key].bundle_output;
                    }
                    if (typeof cf[key].sysTxtKeyHinweis === 'string') {
                        formConfig.items[idx].sysTxtKeyHinweis = cf[key].sysTxtKeyHinweis;
                    }
                    if (cf[key].validMsgStyle) {
                        formConfig.items[idx].validMsgStyle = cf[key].validMsgStyle;
                    }
                    if (typeof cf[key].showFullValidMsg === 'boolean') {
                        formConfig.items[idx].showFullValidMsg = cf[key].showFullValidMsg;
                    }
                    let eventComponent: any = {};
                    if (cf[key].event_handler) {
                        formConfig.items[idx].event_handler = cf[key].event_handler(this, (data: any) => {
                            if (Object.keys((data || {}).state || {}).length) {
                                setTimeout(() => this.setState(data.state));
                            }
                            eventComponent[idx] = data || {};
                        });
                    }
                    if (cf[key].custom_component) {
                        formConfig.items[idx].custom_component = (setValue?: (value: any) => void, elementRef?: any) =>
                            !cf[key].hidden && !cf[key].hidden_input && cf[key].custom_component(this, eventComponent[idx], (data: any) => {
                                if (Object.keys((data || {}).state || {}).length) {
                                    setTimeout(() => this.setState(data.state));
                                }
                            }
                            );
                    }
                }
            });
        }
        switch (this.props.entity.entity) {
            case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF:
            case IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL:
                const config = this.props.data[IDs.ENT_KONFIGURATION][0];
                const detailierteErfassung = config.co2_fussabdruck_modus === 'ghg';
                const arteIdx = formConfig.items.findIndex((i: any) => i.key === 'art_tid');
                if (!detailierteErfassung && arteIdx >= 0) {
                    formConfig.items[arteIdx].custom_component = (temp: any, elementRef: any, elementState?: any) =>
                        <div>
                            {this.getMessage('art_tid', elementRef, elementState)}
                            {this.getMessageIcon('art_tid')}
                        </div>;
                }
                break;
            case IDs.ENT_CO2_SCOPE3_ABFALL: {
                const katIdx = formConfig.items.findIndex((i: any) => i.key === 'kategorie');
                if (katIdx >= 0) {
                    formConfig.items[katIdx].custom_component = (temp: any, elementRef: any, elementState?: any) =>
                        <div>
                            {this.getMessage('kategorie', elementRef, elementState)}
                            {this.getMessageIcon('kategorie')}
                        </div>;
                }
                break;
            }
            case IDs.ENT_CO2_SCOPE3_PENDELN: {
                const entfernungIdx = formConfig.items.findIndex((i: any) => i.key === 'entfernung');
                const verbrauchIdx = formConfig.items.findIndex((i: any) => i.key === 'verbrauch');
                const kostenIdx = formConfig.items.findIndex((i: any) => i.key === 'kosten');
                const hinrueckIdx = formConfig.items.findIndex((i: any) => i.key === 'hin_rueck');
                if (entfernungIdx >= 0) {
                    formConfig.items[entfernungIdx].custom_component = this.getEntfernungBtn;
                }
                if (verbrauchIdx >= 0) {
                    formConfig.items[verbrauchIdx].custom_component = this.getVerbrauchBtn;
                }
                if (kostenIdx >= 0) {
                    formConfig.items[kostenIdx].custom_component = this.getKostenBtn;
                }
                if (hinrueckIdx >= 0) {
                    formConfig.items[hinrueckIdx].custom_component = (temp: any, elementRef: any, elementState?: any) => this.getMessage('hin_rueck', elementRef, elementState);
                }
                break;
            }
            case IDs.ENT_CO2_SCOPE3_REISEN: {
                const entfernungIdx = formConfig.items.findIndex((i: any) => i.key === 'entfernung');
                const firmenfahrzeugIdx = formConfig.items.findIndex((i: any) => i.key === 'firmenfahrzeug');
                const verbrauchIdx = formConfig.items.findIndex((i: any) => i.key === 'verbrauch');
                const kostenIdx = formConfig.items.findIndex((i: any) => i.key === 'kosten');
                const hinrueckIdx = formConfig.items.findIndex((i: any) => i.key === 'hin_rueck');
                if (entfernungIdx >= 0) {
                    formConfig.items[entfernungIdx].custom_component = this.getEntfernungBtn;
                }
                if (firmenfahrzeugIdx >= 0) {
                    formConfig.items[firmenfahrzeugIdx].custom_component =
                        (temp: any, elementRef: any, elementState?: any) => this.getMessage('firmenfahrzeug', elementRef, elementState);
                }
                if (verbrauchIdx >= 0) {
                    formConfig.items[verbrauchIdx].custom_component = this.getVerbrauchBtn;
                }
                if (kostenIdx >= 0) {
                    formConfig.items[kostenIdx].custom_component = this.getKostenBtn;
                }
                if (hinrueckIdx >= 0) {
                    formConfig.items[hinrueckIdx].custom_component = (temp: any, elementRef: any, elementState?: any) => this.getMessage('hin_rueck', elementRef, elementState);
                }
                break;
            }
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT: {
                const entfernungIdx = formConfig.items.findIndex((i: any) => i.key === 'entfernung');
                const lieferantIdx = formConfig.items.findIndex((i: any) => i.key === 'lieferant_tid');
                const transportmittelIdx = formConfig.items.findIndex((i: any) => i.key === 'transportmittel');
                const verbrauchIdx = formConfig.items.findIndex((i: any) => i.key === 'verbrauch');
                const kostenIdx = formConfig.items.findIndex((i: any) => i.key === 'kosten');
                const hinrueckIdx = formConfig.items.findIndex((i: any) => i.key === 'hin_rueck');
                if (entfernungIdx >= 0) {
                    const isMobilitaet = this.apiService.getBereichKey() !== 'handwerk' && (formValues || {}).art === 'mobilitaet';
                    if (isMobilitaet) {
                        // WKETOOL-99
                        formConfig.items[entfernungIdx].custom_component = this.getEntfernungBtnMobi;
                    } else {
                        formConfig.items[entfernungIdx].custom_component = this.getLieferEntfernungBtn;
                    }
                }
                if (lieferantIdx >= 0) {
                    formConfig.items[lieferantIdx].custom_component = this.getLieferantBtn;
                    formConfig.items[lieferantIdx].event_handler = this.getFormEventHandler('editLieferant');
                }
                if (transportmittelIdx >= 0) {
                    formConfig.items[transportmittelIdx].custom_component = formConfig.items[transportmittelIdx].custom_component = () => <div>
                        {this.getMessageIcon('transportmittel')}
                    </div>;
                }
                if (verbrauchIdx >= 0) {
                    formConfig.items[verbrauchIdx].custom_component = this.getVerbrauchBtn;
                }
                if (kostenIdx >= 0) {
                    formConfig.items[kostenIdx].custom_component = this.getKostenBtn;
                }
                if (hinrueckIdx >= 0) {
                    formConfig.items[hinrueckIdx].custom_component = (temp: any, elementRef: any, elementState?: any) => this.getMessage('hin_rueck', elementRef, elementState);
                }
                break;
            }
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT: {
                const entfernungIdx = formConfig.items.findIndex((i: any) => i.key === 'entfernung');
                const lieferantIdx = formConfig.items.findIndex((i: any) => i.key === 'lieferant_tid');
                const transportmittelIdx = formConfig.items.findIndex((i: any) => i.key === 'transportmittel');
                const verbrauchIdx = formConfig.items.findIndex((i: any) => i.key === 'verbrauch');
                const kostenIdx = formConfig.items.findIndex((i: any) => i.key === 'kosten');
                const hinrueckIdx = formConfig.items.findIndex((i: any) => i.key === 'hin_rueck');
                if (entfernungIdx >= 0) {
                    formConfig.items[entfernungIdx].custom_component = this.getLieferEntfernungBtn;
                }
                if (lieferantIdx >= 0) {
                    formConfig.items[lieferantIdx].custom_component = this.getLieferantBtn;
                    formConfig.items[lieferantIdx].event_handler = this.getFormEventHandler('editLieferant');
                }
                if (transportmittelIdx >= 0) {
                    formConfig.items[transportmittelIdx].custom_component = formConfig.items[transportmittelIdx].custom_component = () => <div>
                        {this.getMessageIcon('transportmittel')}
                    </div>;
                }
                if (verbrauchIdx >= 0) {
                    formConfig.items[verbrauchIdx].custom_component = this.getVerbrauchBtn;
                }
                if (kostenIdx >= 0) {
                    formConfig.items[kostenIdx].custom_component = this.getKostenBtn;
                }
                if (hinrueckIdx >= 0) {
                    formConfig.items[hinrueckIdx].custom_component = (temp: any, elementRef: any, elementState?: any) => this.getMessage('hin_rueck', elementRef, elementState);
                }
                break;
            }
        }
        if (this.props.additionalFormItems) {
            formConfig.items = [...formConfig.items, ...this.props.additionalFormItems];
        }
        this.setState({ formConfig });
    }

    render(): JSX.Element {
        // ACHTUNG, Standort fehlt noch ---> machen wir später
        if (!this.state.formConfig) {
            return <div>Lade Konfiguration ...</div>;
        }
        const { showMode, entity, getExtraElement, getExtraElement2, getFunktionBtn, WFormId } = this.props;
        const { formValues, formConfig } = this.state;
        const formData = this.initFormData();
        const preset: any = {};

        if (this.props.standort) {
            preset.standort_tid = this.props.standort.tid;
        }
        const bundleFiltered = filterBundle(entity.entity, entity.bundle, this.props.data, this.props.standort, formValues);

        if (this.props.bundleFilterFunc) {
            this.props.bundleFilterFunc(bundleFiltered, this.props.data);
        }
        let showToolBtn = false;
        const disableToolBtn = false;

        if (typeof getExtraElement === 'function' && formValues) {
            showToolBtn = true;
        }
        let showToolBtn2 = false;
        const disableToolBtn2 = false;

        if (typeof getExtraElement2 === 'function' && formValues) {
            showToolBtn2 = true;
        }

        const extraElement = typeof getExtraElement === 'function' &&
            getExtraElement(this.props.isFirst, this.props.standort, this.props.jahr, entity, formValues, (values: any) => {
                Object.keys(values).forEach((k: any) => {
                    const val = typeof values[k] === 'string' || typeof values[k] === 'number' ? values[k] : '';
                    formData.setValue(k, val);
                });
                this.setState({ renderForm: false }, () => this.onFormChange(formData));
            }, disableToolBtn, null, showMode);

        const extraElement2 = typeof getExtraElement2 === 'function' &&
            getExtraElement2(this.props.isFirst, this.props.standort, this.props.jahr, entity, formValues, (values: any) => {
                Object.keys(values).forEach((k: any) => {
                    const val = typeof values[k] === 'string' || typeof values[k] === 'number' ? values[k] : '';
                    formData.setValue(k, val);
                });
                this.setState({ renderForm: false }, () => this.onFormChange(formData));
            }, disableToolBtn2, 1, showMode);

        const funktionBtn = typeof getFunktionBtn === 'function' && getFunktionBtn(this.props.isFirst, entity, formValues, showMode);

        let extraElementAfter;
        if (showToolBtn && extraElement) {
            if (entity.entity === IDs.ENT_ANABREISE) {
                extraElementAfter = { besucher_erfasst: extraElement };
            } else if (entity.entity === IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE) {
                extraElementAfter = { mitarbeiter_erfasst: extraElement };
            } else {
                extraElementAfter = { abrechnungsmodus: extraElement };
            }
        }

        const extraElementAfter2 = showToolBtn2 && extraElement2 && { bemerkung: extraElement2 };

        // Update formValues
        const formValuesNew = formData.getAllValues();
        const valDiff = this.compareFormValues2(this.state.formValues, formValuesNew);
        if (valDiff > 0) {
            this.setState({ formValues: formValuesNew });
        }
        const hiddenFields = ['gebaeude_tid', 'monat', 'jahr'];
        if (entity.entity !== IDs.ENT_STANDORT) {
            hiddenFields.push('standort_tid');
        }
        const { extraFormElementAfter, extraFormElementBefore } = getExtraFormElement(
            entity.entity, this.state.formValues, this.props.data, {
            hideLabels: !this.props.isFirst, layout: this.props.layout || 'sidebysideComplexGreen',
            posFieldsHelpBeginning: this.props.posFieldsHelpBeginning, showFieldsHelp: true, showMode
        }, (data: any) => {
            Object.keys(data || {}).forEach((key: string) => formData.setValue(key, data[key]));
            this.setState(
                { renderForm: false, formValues: { ...(this.state.formValues || {}), ...(data || {}) } },
                () => {
                    this.onFormChange(formData);
                    window.setTimeout(() => this.setState({ renderForm: true }), 100);
                }
            );
        },
            this.contextService, { jahr: this.props.jahr, standort_tid: (this.props.standort || {}).tid }
        ) || {};

        return (
            <div
                id={this.komplexFormId}
                onClick={(event: any) => {
                    this.props.onCurrentYearChange && this.props.onCurrentYearChange(this.props.jahr);
                    this.currentFormTarget = event.target;
                }}
                onChange={(event: any) => this.currentFormTarget = event.target}
            >
                {this.state.renderForm &&
                    <WForm
                        id={WFormId}
                        entity={entity.entity}
                        module={this.props.module}
                        titel='Formular'
                        layout={this.props.layout || 'sidebysideComplexGreen'}
                        config={formConfig}
                        dataIn={formData}
                        hideAllFields={this.props.hideAllFields}
                        standortSelected={this.props.standort}
                        readOnly={false}
                        showMode={showMode}
                        bundle={bundleFiltered}
                        hiddenFormFields={hiddenFields}
                        preset={preset}
                        onFormChange={this.onFormChange}
                        validateField={this.validateField}
                        onFormSave={() => { }}
                        onFormCancel={() => { }}
                        showFieldsHelp={true}
                        globalData={this.props.data}
                        posFieldsHelpBeginning={this.props.posFieldsHelpBeginning}
                        customCssStyle={{
                            formcontainer: {
                                height: 'unset',
                                minHeight: 'unset',
                                marginTop: 0,
                                overflow: 'visible'
                            },
                            ...this.props.customCssStyle
                        }}
                        hideCancel={true}
                        hideSave={true}
                        hideTitel={true}
                        hideLabels={!this.props.isFirst}
                        inComplexForm={true}
                        disableFieldSelectDefaultOptions={this.props.disableFieldSelectDefaultOptions}
                        selectOptionAsRadio={this.props.selectOptionAsRadio}
                        onValidationStateChange={this.props.onValidationStateChange}
                        enableDidUpdateCheck={
                            entity.entity === IDs.ENT_KLIMAGASE
                        }
                        simpleValidationMsg={this.props.formSimpleValidationMsg}
                        onFormChangeInteractive={this.props.onFormChangeInteractive}
                        externalElement={
                            <div>
                                {/*showToolBtn && entity.entity !== undefined && extraElement*/}
                                {funktionBtn}
                            </div>
                        }
                        extraElementAfter={{ ...(extraFormElementAfter || {}), ...extraElementAfter, ...extraElementAfter2 }}
                        externalDescriptionElement={this.props.externalDescriptionElement}
                        externalTopElement={this.props.externalTopElement}
                        isPruefung={this.props.isPruefung}
                        groupOrder={this.props.formGroupOrder}
                    // Vorbelegung geht direkt durch setDataPreset in DateneingabeCO2Komplex.tsx
                    // valueFieldSelectDefaultOptions bietet keine Vorbelegung der Auswahl, sondern den Ersatz für die Beschriftung "keine Auswahl".
                    // valueFieldSelectDefaultOptions={ // Vorbelegung
                    //     entity.entity === IDs.ENT_CO2_SCOPE3_REISEN && formData.getValue('teilstrecken') === 1 ? { transportmittel: 'mehrere' } : null
                    // }
                    />
                }
                {this.state.showDialog && this.renderDialog()}
                {this.state.infoDlgContent && this.renderInfoDialog()}
            </div>
        );
    }

    initFormData() {
        const { entity } = this.props;
        const { formValues } = this.state;
        const formData = new WFormData();
        formData.setValue('tid', 0);
        formData.setValue('jahr', this.props.jahr);
        formData.setValue('abrechnungszeitraum_von', new Date(`${this.props.jahr}-01-01`).getTime() / 1000);
        formData.setValue('abrechnungszeitraum_bis', new Date(`${this.props.jahr}-12-31`).getTime() / 1000);
        if (formValues) {
            const itemCopy = { ...formValues };
            Object.keys(formValues).forEach((key: string) => {
                if (key.slice(-5) === '_orig') {
                    itemCopy[key.slice(0, -5) + '_name'] = itemCopy[key.slice(0, -5)];
                    itemCopy[key.slice(0, -5)] = formValues[key];
                }
            });
            formData.overwriteAllValues(itemCopy);
        }

        // Im Simple-Mode immer "distance-based" als Standardwert verwenden.
        if (this.teilstreckenEntities.indexOf(entity.entity) >= 0) {
            const konfig = (this.props.data[IDs.ENT_KONFIGURATION] || [])[0] || {};
            if (konfig.co2_fussabdruck_modus === 'simple') {
                formData.setValue('modus', 'distance_based');
            }
        }
        return formData;
    }

    renderInfoDialog(): JSX.Element {
        const { infoDlgContent } = this.state;
        return <div>
            <DialogWrapper2
                onAfterClose={() => {
                    this.setState({ infoDlgContent: null });
                    const contextId = this.getInfoDlgContentContextKey();
                    this.contextService.set(contextId, null);
                }}
            >
                <div style={{ width: 400, height: 300 }}>
                    {infoDlgContent}
                </div>
            </DialogWrapper2>
        </div>;
    }

    getRechnerParams(): any {
        const { formValues, showDialog } = this.state;
        const { data, standort, entity, jahr, isInAssisten, WFormId, onChange, reloadData } = this.props;
        return {
            data,
            entity,
            standortSelected: standort,
            jahr,
            values: formValues,
            onChange: (entityName: string, values: any) => {
                // console.log(showDialog, formValues, values);
                switch (showDialog) {
                    case 'editVerbrauch':
                        // formValues.verbrauch = values.verbrauch;
                        // formValues.energietraeger_tid = null;
                        break;
                    case 'editKosten':
                        formValues.kosten = values.kosten;
                        break;
                    case 'editEntfernung':
                    case 'editEntfernungMobi': // WKETOOL-99
                    case 'editLieferEntfernung':
                        formValues.entfernung = values.entfernung;
                        break;
                }
                const data: any = formValues || {};
                const contextKey: string = this.getContextKey(data.jahr);
                this.contextService.set(contextKey, false);
                this.setState({ showDialog: null, formValues });
                if (typeof onChange === 'function') {
                    this.setState({ isFormSaveDone: false }, () => {
                        onChange(entity.entity, formValues, () => {
                            this.setState({ isFormSaveDone: true });
                        }, 0);
                    });
                }
            },
            onClose: () => this.setState({ showDialog: null }),
            reloadData
        }
    }

    renderDialog(): JSX.Element {
        const { formValues, showDialog, lieferantTid } = this.state;
        const { standort, entity, jahr, onChange, reloadBundle } = this.props;
        const title = `${jahr}\u00A0\u00A0\u00A0\u00A0\u00A0${standort.name}`;
        if (showDialog === 'editVerbrauch') {
            return (
                <div style={{ width: 780, paddingLeft: 20, position: 'absolute' }}>
                    <DialogWrapper2
                        title={title}
                        width={-1}
                        onAfterClose={() => this.setState({ showDialog: null })}
                    >
                        <DialogCO2Verbrauch
                            {... this.getRechnerParams()}
                        />
                    </DialogWrapper2>
                </div>
            );
        } else if (showDialog === 'editKosten') {
            const isMobilitaet: boolean = this.apiService.getBereichKey() !== 'handwerk' && (formValues || {}).art === 'mobilitaet';
            return (
                <div style={{ width: 780, paddingLeft: 20, position: 'absolute' }}>
                    <DialogWrapper2
                        title={title}
                        width={-1}
                        onAfterClose={() => this.setState({ showDialog: null })}
                    >
                        <DialogCO2Kosten
                            {... { ...this.getRechnerParams(), isMobilitaet }}
                        />
                    </DialogWrapper2>
                </div>
            );
        } else if (showDialog === 'editEntfernung') {
            return (
                <div style={{ width: 780, paddingLeft: 20, position: 'absolute' }}>
                    <DialogWrapper2
                        title={title}
                        width={-1}
                        onAfterClose={() => this.setState({ showDialog: null })}
                    >
                        <DialogCO2Entfernung
                            {... this.getRechnerParams()}
                        />
                    </DialogWrapper2>
                </div>
            );
        } else if (showDialog === 'editEntfernungMobi') {
            return (
                <div style={{ width: 780, paddingLeft: 20, position: 'absolute' }}>
                    <DialogWrapper2
                        title={title}
                        width={-1}
                        onAfterClose={() => this.setState({ showDialog: null })}
                    >
                        <DialogCO2EntfernungMobi
                            {... this.getRechnerParams()}
                        />
                    </DialogWrapper2>
                </div>
            );
        } else if (showDialog === 'editLieferEntfernung') {
            return (
                <div style={{ width: 780, paddingLeft: 20, position: 'absolute' }}>
                    <DialogWrapper2
                        title={title}
                        width={-1}
                        onAfterClose={() => this.setState({ showDialog: null })}
                    >
                        <DialogCO2LieferEntfernung
                            {... this.getRechnerParams()}
                        />
                    </DialogWrapper2>
                </div>
            );
        } else if (showDialog === 'editLieferant') {
            return (
                <WFormsTableWrapper
                    entity={IDs.ENT_CO2_SCOPE3_LIEFERANT}
                    module={IDs.MOD_ETOOL}
                    directEditFormularOf={{ tid: lieferantTid }}
                    showDeleteInSaveDialog
                    customClass='Custom-ETA'
                    formLayout='flowV2'
                    onDelDone={(entityName: string, row: any): void => {
                        this.triggerService.fire('reload', IDs.ENT_CO2_SCOPE3_LIEFERANT);
                        if (reloadBundle) {
                            reloadBundle();
                        }
                        if ((row || {}).tid) {
                            formValues.lieferant_tid = null;
                            formValues.lieferant_tid_orig = null;
                            // Dazu noch Umstellung der Auswahlfelder _orig -> _tid...
                            if (formValues.standort_tid_orig > 0) {
                                formValues.standort_tid = formValues.standort_tid_orig;
                            } else if (standort.tid > 0) {
                                formValues.standort_tid = standort.tid;
                            }
                            if (formValues.teilstrecken_orig > 0) {
                                formValues.teilstrecken = formValues.teilstrecken_orig;
                            }
                            this.setState({ formValues });
                            if (typeof onChange === 'function') {
                                this.setState({ isFormSaveDone: false }, () => {
                                    onChange(entity.entity, formValues, () => {
                                        this.setState({ isFormSaveDone: true });
                                    }, 0);
                                });
                            }
                        }
                    }}
                    onSaveDone={(entityName: string, values: any, bundle: any, saveTid?: number) => {
                        this.triggerService.fire('reload', IDs.ENT_CO2_SCOPE3_LIEFERANT);
                        if (reloadBundle) {
                            reloadBundle();
                        }
                        // Beim Anlegen eines neuen Lieferants wird dieser sofort ausgewählt.
                        if (saveTid > 0) {
                            formValues.lieferant_tid = saveTid;
                            formValues.lieferant_tid_orig = saveTid;
                            formValues.lieferant_tid_name = values.name;
                            // Dazu noch Umstellung der Auswahlfelder _orig -> _tid...
                            if (formValues.standort_tid_orig > 0) {
                                formValues.standort_tid = formValues.standort_tid_orig;
                            } else if (standort.tid > 0) {
                                formValues.standort_tid = standort.tid;
                            }
                            if (formValues.teilstrecken_orig > 0) {
                                formValues.teilstrecken = formValues.teilstrecken_orig;
                            }
                            this.setState({ formValues });
                            if (typeof onChange === 'function') {
                                this.setState({ isFormSaveDone: false }, () => {
                                    onChange(entity.entity, formValues, () => {
                                        this.setState({ isFormSaveDone: true });
                                    }, 0);
                                });
                            }
                        }
                    }}
                    validateField={(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string =>
                        validateFieldUniversal(IDs.ENT_CO2_SCOPE3_LIEFERANT, key, value, data, onValueChange)
                    }
                    onAfterAction={(action: string) => {
                        if (action === 'closeForm') {
                            this.setState({ showDialog: null });
                        }
                    }}
                    callBeforeOnFormSave={(data: any, callback: () => void) => {
                        if (data) {
                            const fnd = (this.props.data[IDs.ENT_CO2_SCOPE3_LIEFERANT] || []).find((r: any) => r.tid !== data.tid && r.name === data.name);
                            if (fnd) {
                                alert('Ein gleichnamiger Datensatz existiert bereits.');
                                // console.log(fnd);
                                return;
                            }
                        }
                        callback();
                    }}
                />
            );
        } else if (showDialog === 'sendServiceMail') {
            const title: string = this.props.entity.entity === IDs.ENT_CO2_SCOPE3_ABFALL
                ? 'Abfall - Kategorie'
                : this.props.entity.entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF
                    ? 'Gütereinkauf - Art'
                    : 'Emissionsfaktor';
            return (
                <div style={{ width: 780, paddingLeft: 20, position: 'absolute' }}>
                    <DialogWrapper2
                        title={title}
                        width={-1}
                        onAfterClose={() => this.setState({ showDialog: null })}
                    >
                        <DialogCO2ServiceMail
                            data={this.props.data}
                            entity={entity}
                            values={formValues}
                            onClose={() => this.setState({ showDialog: null })}
                        />
                    </DialogWrapper2>
                </div>
            );
        }
    }

    setDialogState(prevData: any): void {
        const data: any = this.state.formValues || {};
        const key: string = this.getDialogKey() || null;
        prevData = prevData || {};
        if (key) {
            const entity: string = this.props.entity.entity || null;
            const contextKey: string = this.getContextKey(this.props.jahr);
            const isValueChanged = (name: string, value: number | string): boolean => {
                return !!((data[name] || null) === value && this.props.jahr
                    && ((prevData[name] || null) !== value
                        || ((this.contextService.get(`${contextKey}-prev`) || {})[name] || null) !== value || !(+data.tid || 0)
                    )
                );
            };
            if (isValueChanged('teilstrecken_orig', 1)
                || (entity === IDs.ENT_CO2_SCOPE3_ABFALL && isValueChanged('kategorie', 'weitere'))
                || (entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF && isValueChanged('art_tid', -1))) {
                this.contextService.set(contextKey, true);
                this.contextService.set(`${contextKey}-prev`, data);
            } else if (
                this.contextService.get(contextKey)
                && (data.teilstrecken_orig === 1 || data.kategorie === 'weitere' || data.art_tid === -1)
            ) {
                this.setState({ showDialog: key });
            }
            if (this.contextService.get(contextKey) && this.state.isFormSaveDone && data.tid) {
                this.contextService.set(contextKey, false);
                this.setState({ showDialog: null });
            }

            // Reset contextKeys der gleichen Gruppe
            const contxKeys = this.contextService.getObjectKeys();
            const contxBaseKey = this.getContextKey(this.props.jahr, 'edit');
            const contxRelKeys = contxKeys.filter((k: string) => k.startsWith(contxBaseKey) && !k.endsWith('-prev') && k !== contextKey);
            if (contxRelKeys.length > 0) {
                if (data.teilstrecken_orig === 1) {
                    if (isValueChanged('modus', data.modus)) {
                        contxRelKeys.forEach((k: string) => this.contextService.set(k, true));
                    }
                } else {
                    contxRelKeys.forEach((k: string) => this.contextService.set(k, false));
                }
            }
        }
    }

    setMessage(prevData: any): void {
        const data: any = this.state.formValues || {};
        const entity: string = this.props.entity.entity || null;
        let id: string = null;
        let element: HTMLDivElement = null;
        prevData = prevData || {};

        if (typeof data.tid !== 'number') {
            return;
        }

        switch (entity) {
            case IDs.ENT_CO2_SCOPE3_ABFALL: {
                const kategorie: string = data.kategorie || null;
                const prevKategorie: string = prevData.kategorie || null;
                if (
                    (kategorie === 'kunststoff' && (prevKategorie !== 'kunststoff' || !data.tid)) ||
                    (kategorie === 'metall' && (prevKategorie !== 'metall' || !data.tid))
                ) {
                    id = this.getMsgId('kategorie');
                    element = document.getElementById(id) as HTMLDivElement;
                } else if (kategorie === 'weitere' && (prevKategorie !== 'weitere' || !data.tid)) {
                    // const formValues: any = { ...data, kategorie: prevKategorie };
                    // this.setState({ showDialog: 'sendServiceMail', formValues });
                    // this.setOnChange(formValues);
                    // return;
                }
                break;
            }
            case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF: {
                const art: number | string = data.art_tid || null;
                const prevArt: number | string = prevData.art_tid || null;
                if (art === -2 && (prevArt !== -2 || !data.tid)) {
                    id = this.getMsgId('art_tid');
                    element = document.getElementById(id) as HTMLDivElement;
                } else if (art === -1 && (prevArt !== -1 || !data.tid)) {
                    // const formValues: any = { ...data, art_tid: prevArt };
                    // this.setState({ showDialog: 'sendServiceMail', formValues });
                    // this.setOnChange(formValues);
                    // return;
                }
                break;
            }
            case IDs.ENT_CO2_SCOPE3_REISEN: {
                const fnd = (this.props.data[IDs.ENT_CO2_SCOPE3_REISEN] || []).find((r: any) => r.tid === data.tid);
                if (data.firmenfahrzeug_orig === 1 && (!fnd || fnd.firmenfahrzeug_orig !== 1)) {
                    id = this.getMsgId('firmenfahrzeug');
                    element = document.getElementById(id) as HTMLDivElement;
                } else if (
                    (data.hasOwnProperty('hin_rueck_orig') && data.hin_rueck_orig === 2 && (!fnd || fnd.hin_rueck_orig !== 2))  // Ja -> Nein
                    || (!data.hasOwnProperty('hin_rueck_orig') && data.hin_rueck === 2) // Keine Auswahl -> Nein
                    || (data.hasOwnProperty('hin_rueck_orig') && data.hin_rueck_orig === 1 && (!fnd || fnd.hin_rueck_orig !== 1))  // Nein -> Ja
                    || (!data.hasOwnProperty('hin_rueck_orig') && data.hin_rueck === 1) // Keine Auswahl -> Ja
                ) {
                    // Siehe auch onFormChangeCO2ScopeReisen(), AssistentEntityForm.getFormKey()
                    id = this.getMsgId('hin_rueck');
                    element = document.getElementById(id) as HTMLDivElement;
                }
                break;
            }
            case IDs.ENT_CO2_SCOPE3_PENDELN: {
                const fnd = (this.props.data[IDs.ENT_CO2_SCOPE3_PENDELN] || []).find((r: any) => r.tid === data.tid);
                if (
                    (data.hasOwnProperty('hin_rueck_orig') && data.hin_rueck_orig === 2 && (!fnd || fnd.hin_rueck_orig !== 2))  // Ja -> Nein
                    || (!data.hasOwnProperty('hin_rueck_orig') && data.hin_rueck === 2) // Keine Auswahl -> Nein
                    || (data.hasOwnProperty('hin_rueck_orig') && data.hin_rueck_orig === 1 && (!fnd || fnd.hin_rueck_orig !== 1))  // Nein -> Ja
                    || (!data.hasOwnProperty('hin_rueck_orig') && data.hin_rueck === 1) // Keine Auswahl -> Ja
                ) {
                    // Siehe auch onFormChangeCO2ScopeReisen(), AssistentEntityForm.getFormKey()
                    id = this.getMsgId('hin_rueck');
                    element = document.getElementById(id) as HTMLDivElement;
                }
                break;
            }
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
                const fnd = (this.props.data[entity] || []).find((r: any) => r.tid === data.tid);
                // Siehe auch onFormChangeCO2ScopeNachgelagert(), AssistentEntityForm.getFormKey()
                if (
                    (data.hasOwnProperty('hin_rueck_orig') && data.hin_rueck_orig === 2 && (!fnd || fnd.hin_rueck_orig !== 2))  // Ja -> Nein
                    || (!data.hasOwnProperty('hin_rueck_orig') && data.hin_rueck === 2) // Keine Auswahl -> Nein
                ) {
                    id = this.getMsgId('hin_rueck');
                    element = document.getElementById(id) as HTMLDivElement;
                }
                break;
        }

        if (id && element !== null) {
            this.contextService.set(id, true);
            element.style.display = 'block'
        }
    }

    setOnChange(formValues: any): void {
        if (typeof this.props.onChange === 'function' && formValues) {
            this.setState({ isFormSaveDone: false }, () => {
                this.props.onChange(this.props.entity.entity, formValues, () => {
                    this.setState({ isFormSaveDone: true });
                }, 0);
            });
        }
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        const entity: string = this.props.entity.entity;
        let inputOnly: boolean = false;
        let type: string = null;
        const field: string = validateFieldUniversal(
            entity, key, value, data, onValueChange, this.props.data,
            (info: any) => {
                inputOnly = !!(info || {}).inputOnly;
                type = (info || {}).type || null;
            }
        );
        const values: any = data.values || {};
        const tid: number = +values.tid || null;

        Object.keys(this.required).forEach((key2: string) => {
            const value2: any = values[key2];

            if (
                tid
                && (typeof value2 === 'undefined' || value2 === null || value2 === ''
                    || ((this.required[key2] || {}).type === 'select' && value2 == 0)
                )
                && Object.keys(this.required).indexOf(key2) !== -1 && !isFieldHidden(entity, key2, data.values || {}, this.props.data)
            ) {
                this.validation[key2] = { text: [`Bitte Feld '${this.required[key2].name || ''}' ausfüllen`], type: 'error' };
            } else if (!tid) {
                this.validation[key2] = null;
            }
        });

        if (tid && !isFieldHidden(entity, key, data.values || {}, this.props.data) && !inputOnly) {
            this.validation[key] = field
                ? {
                    text: (field || '').toString().split('\n').map((line: string) => line),
                    ...(type && { type })
                }
                : null;
        } else {
            this.validation[key] = null;
        }

        if (typeof this.props.onValidate === 'function') {
            this.props.onValidate({
                entity,
                jahr: this.props.jahr,
                tid: (data.values || {}).tid || null,
                fields: this.validation
            });
        }

        return field;
    }

    getFormEventHandler(key: string) {
        // WKETOOL-121: 189 Im Dropdown soll es möglich sein, eine initiale Option hinzuzufügen
        if (key === 'editLieferant') {
            return {
                onMenuOpen: (params?: any) => {
                    const bundle = (params || {}).bundleData;
                    // console.log(bundle);
                    if (Array.isArray(bundle) && bundle.length === 0) {
                        setTimeout(() => this.setState({ showDialog: 'editLieferant', lieferantTid: 0 }), 100);
                    }
                }
            };
        }
    }
}
